// NOTE: Only add here if you need translations
//       to be available from the widgets, as the widgets
//       cannot access Sanity CMS for translations!
export const pt = {
  'recipe.pax.adult_one': 'adulto',
  'recipe.pax.adult_plural': 'adultos',
  'recipe.pax.child_one': 'criança',
  'recipe.pax.child_plural': 'crianças',
  'categories.multiStopText': 'Várias paragens',
  'price.total': 'Desde',
  'price.shortFrom': 'Desde',
  'price.example': 'Exemplo de preço:',
  'price.pricePerPerson': 'Preço por pessoa',
  'ui.action.share': 'Partilhar',
  'ui.action.book': 'Reservar',
  'ui.action.view': 'Ver',
  'ui.action.width': 'Largura',
  'ui.action.style': 'Estilo',
  'ui.action.preview': 'Pré-visualização',
  'ui.action.copy_link': 'Copiar link',
  'ui.action.copy_code': 'Copiar código',
  'ui.action.explore_and_publish': 'Copiar receita',
  'ui.notice.copied': 'Copiado',
  'ui.instruction.paste_body': 'Copie para a tag body da sua página',
  'ui.instruction.paste_head': 'Copie para a tag head da sua página',
  'ui.label.widget_builder': 'Copiar html',
  'day.single': 'dia',
  'night.single': 'noite',
  'night.plural': 'noites',
  'ui.action.close': 'Fechar',
  'ui.shareModal.header': 'Partilhar e guardar a sua viagem',
  'ui.shareModal.action.saveTrip.label': 'Guardar viagem',
  'ui.shareModal.action.saveTrip.saved': 'A sua viagem foi guardada.',
  'ui.action.logIn.header': 'Iniciar sessão para continuar',
  'ui.action.register.header': 'Criar conta',
  'ui.action.forgottenPassword.header': 'Redefinir palavra-passe',
  'ui.action.register.firstName.label': 'Nome próprio',
  'ui.action.register.firstName.placeholder': 'Nome próprio',
  'ui.action.register.lastName.label': 'Apelido',
  'ui.action.register.lastName.placeholder': 'Apelido',
  'ui.action.register.name.requiredError': 'Introduza o nome',
  'ui.action.register.email.label': 'E-mail',
  'ui.action.register.email.placeholder': 'E-mail',
  'ui.action.register.email.requiredError': 'Introduza o e-mail',
  'ui.action.register.password.label': 'Palavra-passe',
  'ui.action.register.password.placeholder': 'Palavra-passe',
  'ui.action.register.password.requirements': 'Introduza a palavra-passe',
  'ui.action.register.password.requiredError': 'Introduza a palavra-passe',
  'ui.action.register.password.minLengthError':
    'Introduza pelo menos 6 caracteres',
  'ui.action.register.password.maxLengthError': 'Máximo de 50 caracteres',
  'ui.action.register.confirmPassword.label': 'Confirmar palavra-passe',
  'ui.action.register.confirmPassword.placeholder': 'Confirmar palavra-passe',
  'ui.action.register.confirmPassword.requiredError':
    'Introduza a palavra-passe',
  'ui.action.register.confirmPassword.noMatchError':
    'As palavras-passe não coincidem',
  'ui.action.register.newsletter.info':
    'Quero receber newsletters com inspiração e ofertas da Sembo',
  'ui.action.register.sembonus.prefix': 'Junte-se ao',
  'ui.action.register.sembonus.linkLabel': 'Sembonus',
  'ui.action.register.sembonus.suffix':
    'gratuitamente. Ganhe 1 noite bónus a cada 10 estadias.',
  'ui.action.register.genericError':
    'Algo correu mal, por favor tente novamente mais tarde',
  'ui.action.register.emailAlreadyExistsError':
    'Este e-mail já está registado. Por favor, inicie sessão ou use outro e-mail.',
  'ui.action.register.termsAndConditions.info':
    'Ao clicar em "Criar conta" aceito os',
  'ui.action.register.termsAndConditions.linkLabel': 'Termos',
  'ui.action.register.submitButton.label': 'Criar conta',
  'ui.action.register.submitButton.loading': 'A carregar',
  'ui.action.register.logIn': 'Iniciar sessão',
  'ui.action.logIn.username.label': 'E-mail',
  'ui.action.logIn.username.placeholder': 'E-mail',
  'ui.action.logIn.username.requiredError': 'Introduza o e-mail',
  'ui.action.logIn.password.label': 'Palavra-passe',
  'ui.action.logIn.password.placeholder': 'Palavra-passe',
  'ui.action.logIn.password.requiredError': 'Introduza a palavra-passe',
  'ui.action.logIn.genericError': 'E-mail ou palavra-passe incorretos',
  'ui.action.logIn.forgotenPassword': 'Esqueceu-se da palavra-passe?',
  'ui.action.logIn.submitButton.label': 'Iniciar sessão',
  'ui.action.logIn.submitButton.loading': 'A carregar',
  'ui.action.logIn.register': 'Criar conta',
  'ui.action.forgottenPassword.requestSent':
    'Foi enviado um e-mail com instruções sobre como redefinir a palavra-passe.',
  'ui.action.forgottenPassword.clickToLoginText':
    'Clique no botão abaixo para iniciar sessão novamente.',
  'ui.action.forgottenPassword.logIn': 'Iniciar sessão',
  'ui.action.forgottenPassword.email.label': 'E-mail',
  'ui.action.forgottenPassword.email.placeholder': 'E-mail',
  'ui.action.forgottenPassword.email.requiredError': 'Introduza o e-mail',
  'ui.action.forgottenPassword.genericError':
    'Algo correu mal, por favor tente novamente mais tarde',
  'ui.action.forgottenPassword.submitButton.label': 'Redefinir palavra-passe',
  'ui.action.forgottenPassword.submitButton.loading': 'A carregar',
  'ui.action.forgottenPassword.cancel': 'Cancelar',
  'ui.shareModal.action.saveTrip.testInfo':
    'Olá! Estamos a desenvolver esta funcionalidade. De momento, pode guardar e retomar a sua viagem facilmente clicando no botão "Copiar link". Obrigado pela compreensão!',
  'ui.shareModal.tripName.label': 'Nome da viagem (opcional)',
  'ui.shareModal.tripName.placeholder': 'Adicione um nome',
  'ui.shareModal.unauthorizedAlert.header': 'Inicie sessão ou crie uma conta',
  'ui.shareModal.unauthorizedAlert.content':
    'A sua viagem será guardada e estará disponível a qualquer momento, em qualquer dispositivo.',
  'ui.shareModal.action.saveTrip.authorized.label': 'Guardar viagem',
  'ui.shareModal.action.saveTrip.unauthorized.label':
    'Iniciar sessão para guardar',
  'ui.action.accountCreated.title': 'Conta criada',
  'ui.action.accountCreated.description':
    'A sua conta está pronta e agora está com sessão iniciada',
};
